import { ValidatorFn, AbstractControl } from '@angular/forms';
import { isGTIN } from 'gtin';

export function GtinValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    try {
      if (isGTIN(control.value)) {
        return null;
      }
    } catch (error) {
      return { gtinInvalid: true, gtinError: error };
    }

    return { gtinInvalid: true };
  };
}
